import CourseForm from './CourseForm';

const AddCourse = () => {
  return <CourseForm />;
};

export default AddCourse;
